// src/utils/exportToWord.js

/**
 * 将HTML内容导出为Word文档 (.doc)
 * 注意：此方法生成的是 .doc 格式（兼容模式），非 .docx
 * @param {string} htmlContent - 要导出的HTML字符串
 * @param {string} filename - 导出的文件名
 */
export function exportToWord(htmlContent, filename = 'document.doc') {
  const fullHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:w="urn:schemas-microsoft-com:office:word"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="UTF-8">
        <title>Exported Document</title>
        <!--[if gte mso 9]>
        <xml>
          <w:WordDocument>
            <w:View>Print</w:View>
            <w:Zoom>100</w:Zoom>
            <w:DoNotOptimizeForBrowser/>
          </w:WordDocument>
        </xml>
        <![endif]-->
        <style>
          body { font-family: "Microsoft YaHei", sans-serif; line-height: 1.6; }
          table { border-collapse: collapse; }
          td, th { border: 1px solid #000; padding: 8px; }
        </style>
      </head>
      <body>
        ${htmlContent}
      </body>
    </html>
  `;

  const blob = new Blob([fullHtml], {
    type: 'application/msword'
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}